import { AEROPRESS_VARIATIONS, VALID_AERO_PRESS_FOR_CONNECTION_GRIND } from "@client-shared/lib";
import { stripHtml } from "string-strip-html";

export const htmlToPlainText = (html: string | undefined) => {
  if (!html) {
    return undefined;
  }
  const stripped = stripHtml(html);
  return stripped?.result || undefined;
};

export const detectAllowedValuesFromString = (stringToSample: string | undefined, options: string[]) => {
  const sampleKey = stringToSample?.toLocaleLowerCase().replaceAll(" ", "");
  return options.find((option) => sampleKey?.includes(option.toLocaleLowerCase().replaceAll(" ", "")));
};

export const sanitizeAeroPressGrind = (grindType: string) => {
  if (!AEROPRESS_VARIATIONS.includes(grindType)) {
    return grindType;
  }
  return VALID_AERO_PRESS_FOR_CONNECTION_GRIND;
};

export const detectedAllowedGrindsFromString = (stringToSample: string | undefined, options: string[]) => {
  const detectedGrinds = new Set<string>();
  if (!stringToSample || !options.length) {
    return [...detectedGrinds];
  }

  const normalizedSample = stringToSample.toLowerCase().replaceAll(/\s+/g, "");

  // Sort options by length (longest first) to prioritize more specific matches
  const sortedOptions = [...options].sort((a, b) => b.length - a.length);

  sortedOptions.forEach((option) => {
    const normalizedOption = option.toLowerCase().replaceAll(/\s+/g, "");
    if (normalizedSample.includes(normalizedOption)) {
      // Check if this grind is a substring of an already detected grind
      const isSubstringOfDetected = [...detectedGrinds].some((detectedGrind) => {
        const normalizedDetected = detectedGrind.toLowerCase().replaceAll(/\s+/g, "");
        return normalizedDetected.includes(normalizedOption);
      });

      // Only add if it's not already a substring of a detected grind
      if (!isSubstringOfDetected) {
        const alreadyExists = [...detectedGrinds].some((grind) => grind.toLowerCase().replaceAll(/\s+/g, "") === normalizedOption);
        if (!alreadyExists) {
          detectedGrinds.add(sanitizeAeroPressGrind(option.trim()));
        }
      }
    }
  });
  return [...detectedGrinds];
};
